import sysEnv from '@/env/envs'

import {
  mapGetDataNew,
  mapGetDepot
} from '@/api/api'

import {
  tlLines,
  gdLines,
  gdLines2
} from '@/cllib/tlPoint'

import {
  pointAggregation
} from '@/cllib/sys_lib'

import {
  convertData,
  tooltipF1,
  tooltipF2,
  shiZb
} from './map_lib'

import {
  initGasOptionNew,
  pointChange,
  addEvent,
  mapXzqh,
  setMapViewport,
  xzqhStyleConfig,
  updateMapCenterAndZoom
} from '@/cllib/mapTools'

import Vue from 'vue'

let echarts = require('echarts')

const initStateData = function () {
  let data = {
    mapSourceData: [],
    mapSourceDataOther: {},
    mapAreaShi: [],
    mapAreaSheng: [{name: '云南省', level: 'sheng'}],
    mapViewType: '',
    mapLoading: 0,
    mapOption: null,
    mapChartMapZoom: 8,
    mapChartIsBrush: false,
    mapChartSelectData: [],
    mapChartSearchData: [],
    mapChartClick: false,
    mapInitConfig: {
      zoom: 8,
      ponit: [101.88, 25.069329]
    },
    mapChartClickGasName: null,
    mapLegendseStatus: {
      [sysEnv.zsyName]: true,
      '中石化': false,
      '社会站': false,
      '油库': false,
      [sysEnv.zsyName + '管道']: false,
      '中石化管道': false,
      '铁路': false
    },
    mapSeriesData: [[], [], [], [], [], [], [], []],
    mapBackCurrentAreaing: false,
    mapCurrentArea: {
      sheng: '云南省',
      shi: null,
      qx: null
    },
    mapCurrentHoverArea: null,
    mapMouseMoveIng: false,
    mapNoGas: false,
    mapNoDepot: false,
    mapDownType: '',
    mousePonit: null,
    mapOverChart: false,
    mapChooseDepot: null,
    mapChoosePipe: null
  }
  return data
}

const clearStateData = function (state) {
  let data = {
    mapSourceData: [],
    mapSourceDataOther: {},
    mapAreaShi: [],
    mapAreaSheng: [{name: '云南省', level: 'sheng'}],
    mapLoading: 0,
    mapOption: null,
    mapChartMapZoom: 8,
    mapChartIsBrush: false,
    mapChartSelectData: [],
    mapChartSearchData: [],
    mapChartClick: false,
    mapChartClickGasName: null,
    mapLegendseStatus: {
      [sysEnv.zsyName]: true,
      '中石化': false,
      '社会站': false,
      '油库': false,
      [sysEnv.zsyName + '管道']: false,
      '中石化管道': false,
      '铁路': false
    },
    mapSeriesData: [[], [], [], [], [], [], [], []],
    mapBackCurrentAreaing: false,
    mapCurrentArea: {
      sheng: '云南省',
      shi: null,
      qx: null
    },
    mapMouseMoveIng: false,
    mapCurrentHoverArea: null,
    mapNoGas: false,
    mapNoDepot: false,
    mapDownType: '',
    mousePonit: null,
    mapOverChart: false,
    mapChooseDepot: null,
    mapChoosePipe: null
  }
  for (let key in data) {
    state[key] = data[key]
  }
}

const state = initStateData()

window.mapAreaHzHis = []

const getters = {
  mapViewType: state => state.mapViewType,
  mapSourceData: state => state.mapSourceData,
  mapSourceDataOther: state => state.mapSourceDataOther,
  mapAreaShi: state => state.mapAreaShi,
  mapAreaSheng: state => state.mapAreaSheng,
  mapLoading: state => state.mapLoading,
  mapOption: state => state.mapOption,
  mapChartMapZoom: state => state.mapChartMapZoom,
  mapChartIsBrush: state => state.mapChartIsBrush,
  mapChartSelectData: state => state.mapChartSelectData,
  mapChartSearchData: state => state.mapChartSearchData,
  mapChartClick: state => state.mapChartClick,
  mapChartClickGasName: state => state.mapChartClickGasName,
  mapLegendseStatus: state => state.mapLegendseStatus,
  mapSeriesData: state => state.mapSeriesData,
  mapBackCurrentAreaing: state => state.mapBackCurrentAreaing,
  mapCurrentArea: state => state.mapCurrentArea,
  mapCurrentHoverArea: state => state.mapCurrentHoverArea,
  mapNoGas: state => state.mapNoGas,
  mapNoDepot: state => state.mapNoDepot,
  mapMouseMoveIng: state => state.mapMouseMoveIng,
  mapChooseDepot: state => state.mapChooseDepot,
  mapChoosePipe: state => state.mapChoosePipe,
  // main 下钻 区县销量占比
  // '' 不需要
  // ls 不下钻 市级销量情况
  mapInitConfig: state => state.mapInitConfig,
  mapDownType: state => state.mapDownType,
  mousePonit: state => state.mousePonit,
  mapXzqhHzLevel: (state) => {
    let data = ['sheng']
    if (state.mapDownType === 'ls') {
      data.push('shi')
    } else if (state.mapDownType === 'main') {
      data.push('shi')
      data.push('qx')
    }
    return data
  },
  mapOverChart: state => state.mapOverChart
}

const actions = {
  mapClearData ({ dispatch, commit }) {
    commit('mapClearData')
    window.mapAreaHzHis = []
    window.initMapBaidu = null
    window.myMapChartMap = null
    window.myMapChartMapMap = null
    dispatch('mapSeriesDataClear')
  },
  createMapChart ({ dispatch }, domId) {
    window.initMapBaidu = function () {
      dispatch('initMapChart')
    }
    window.myMapChartMap = echarts.init(document.getElementById(domId))
    // addEvent(window.myMapChartMap, 'brushselected', function (data) {
    //   dispatch('mapChartSelected', data)
    // })
    addEvent(window.myMapChartMap, 'mouseover', function (data) {
      dispatch('setMapOverChart', true)
    })
    addEvent(window.myMapChartMap, 'mouseout', function (data) {
      dispatch('setMapOverChart', false)
    })
    addEvent(window.myMapChartMap, 'legendselectchanged', function (data) {
      dispatch('setMapLegendseStatus', data.selected)
    })
    addEvent(window.myMapChartMap, 'click', function (data) {
      dispatch('mapChartClickGas', data)
    })
    dispatch('mapLoadBmapApi')
  },
  mapChartClickGas ({ dispatch }, params) {
    dispatch('setMapChooseDepot', null)
    dispatch('setMapChoosePipe', null)
    dispatch('setMapChartClick', true)
    if (params.componentType === 'series' && params.componentSubType === 'scatter' && ['gas_zsy', 'gas_zsh', 'gas_zy'].includes(params.seriesId) && !Number(params.name)) {
      dispatch('setMapChartClickGasName', params.name)
    }
    if (params.componentType === 'series' && params.componentSubType === 'scatter' && params.seriesId.includes('depot')) {
      dispatch('setMapChooseDepot', params.data.data)
    }
    // if (params.componentType === 'series' && params.componentSubType === 'lines' && params.seriesId.includes('pipe')) {
    //   dispatch('setMapChoosePipe', params.name)
    // }
  },
  mapLoadYKData ({ dispatch, getters }) {
    if (getters.mapNoDepot) {
      dispatch('setMapLoading', getters.mapLoading + 1)
      return
    }
    // 获取油库和管道铁路
    mapGetDepot().then((data) => {
      let seriesData3Zsy1 = []
      let seriesData3Zsy2 = []
      let seriesData3Zsy3 = []
      let seriesData3Zsh = []
      let seriesData3Sh = []
      let seriesData3Gc = []
      let seriesData3Zhy = []
      let seriesData4 = []
      let seriesData5 = []
      let seriesData6 = []
      data.data.forEach((item) => {
        let newName = item.name.split('昆明').join('')
        newName = newName.includes('云南地付') ? '云南地付' : newName
        let obj = {
          name: newName,
          type: item.type,
          company: item.company,
          lng: item.lng,
          lat: item.lat,
          o0: item.o0,
          o92: item.o92,
          o95: item.o95,
          o98: item.o98,
          tag: item.tag,
          level: item.level,
          zcType: item.asset_type,
          code: item.code
        }
        if (item[2] === '油库') {
          if (obj.company === sysEnv.zsyName) {
            if (obj.tag === '管道库') {
              seriesData3Zsy1.push({
                name: obj.name,
                value: pointChange([obj.lng, obj.lat]),
                data: obj
              })
            } else if (obj.tag === '地付') {
              seriesData3Zsy3.push({
                name: obj.name,
                value: pointChange([obj.lng, obj.lat]),
                data: obj
              })
            } else {
              seriesData3Zsy2.push({
                name: obj.name,
                value: pointChange([obj.lng, obj.lat]),
                data: obj
              })
            }
          } else if (obj.company === '中石化') {
            seriesData3Zsh.push({
              name: obj.name,
              value: pointChange([obj.lng, obj.lat]),
              data: obj
            })
          } else if (obj.company === '国储') {
            seriesData3Gc.push({
              name: obj.name,
              value: pointChange([obj.lng, obj.lat]),
              data: obj
            })
          } else if (obj.company === '中航油') {
            seriesData3Zhy.push({
              name: obj.name,
              value: pointChange([obj.lng, obj.lat]),
              data: obj
            })
          } else if (obj.company === '社会') {
            seriesData3Sh.push({
              name: obj.name,
              value: pointChange([obj.lng, obj.lat]),
              data: obj
            })
          }
        }
      })
      tlLines.forEach((item) => {
        seriesData6.push({
          name: item.name,
          coords: JSON.parse(item.ponits)
        })
      })
      gdLines.forEach((item) => {
        seriesData4.push({
          name: item.name,
          coords: JSON.parse(item.ponits),
          data: item
        })
      })
      gdLines2.forEach((item) => {
        seriesData5.push({
          name: item.name,
          coords: JSON.parse(item.ponits)
        })
      })
      let otherSourceData = {
        ykZsy1: seriesData3Zsy1,
        ykZsy2: seriesData3Zsy2,
        ykZsy3: seriesData3Zsy3,
        ykZsh: seriesData3Zsh,
        ykGc: seriesData3Gc,
        ykZhy: seriesData3Zhy,
        ykSh: seriesData3Sh,
        gxZsy: seriesData4,
        gxZsh: seriesData5,
        tl: seriesData6
      }
      dispatch('setMapSourceDataOther', otherSourceData)
      dispatch('addMapSeriesData', {index: 6, data: seriesData6})
      dispatch('setMapLoading', getters.mapLoading + 1)
    })
  },
  updateMapChartSearchData ({ getters, dispatch }) {
    let searchData = []
    getters.mapSourceData.forEach((item, index) => {
      if (getters.mapLegendseStatus[item.group] &&
        getters.mapChooseSaleType.includes(item.saleType) &&
        (!getters.mapChooseGasType || item.gasType === getters.mapChooseGasType) &&
        (getters.mapChooseOil === 'all' || item[getters.mapChooseOil]) &&
        (getters.mapChooseCmp === 'all' || item.cmp === getters.mapChooseCmp) &&
        (!getters.mapCurrentArea.shi || getters.mapCurrentArea.shi === item.area) &&
        (!getters.mapCurrentArea.qx || getters.mapCurrentArea.qx === item.areaQx)) {
        searchData.push(item)
      }
    })
    dispatch('setMapChartSearchData', searchData)
  },
  mapChartSelected ({ dispatch }, data) {
    dispatch('setMapChartIsBrush', window.myMapChartMap.getModel().getComponent('brush').brushOption.brushType)
    let selectedData = []
    let selecteds = data.batch[0].selected
    let series = window.myMapChartMap.getOption().series
    selecteds.forEach((item, index) => {
      if (['gas_zsy', 'gas_zy', 'gas_zsh'].includes(item.seriesId)) {
        series[item.seriesIndex].data.forEach((itemOne, indexOne) => {
          if (item.dataIndex.includes(indexOne)) {
            if (itemOne.data && itemOne.data.length) {
              itemOne.data.forEach((dataItem) => {
                selectedData.push(dataItem.data)
              })
            } else {
              selectedData.push(itemOne.data)
            }
          }
        })
      }
    })
    dispatch('setMapChartSelectData', selectedData)
  },
  initMapChart ({ getters, dispatch }, domId) {
    let depotBaseSize = getters.mapViewType === 'cc' ? 150 : 100
    let getSizeFun = (data) => {
      let zoom = getters.mapChartMapZoom
      let size = 30
      if (data) {
        size = getters.mapChooseOil === 'all' ? (data['size' + getters.mapChooseVolumeType] || 0) : (data[String(getters.mapChooseOil)] ? (data[String(getters.mapChooseOil)]['size' + getters.mapChooseVolumeType] || 0) : 0)
      }
      if (!size) {
        size = data.length + 30
        size = size > 65 ? 65 : size
      }
      if (data && data.isWarning) {
        size = size * 3
      }
      if (data && data.seriesId && data.seriesId.includes('depot')) {
        size = depotBaseSize / (Number(data.data.level) || 3)
      }
      return size * zoom / (zoom < 9 ? 25 : 15)
    }
    let tooltipF = getters.userInfo.currentRole && getters.userInfo.currentRole.name === '数据分析' ? tooltipF1 : tooltipF2
    let option = initGasOptionNew(getSizeFun, getters.mapSeriesData, tooltipF, getters.mapLegendseStatus, getters.mapInitConfig, getters.mapViewType === 'cc')
    window.myMapChartMap.setOption(option, false, false, false)
    dispatch('initMapChartMap')
  },
  initMapChartMap ({ commit, dispatch, getters }) {
    // 初始化chart的map
    window.myMapChartMapMap = window.myMapChartMap.getModel().getComponent('bmap').getBMap()
    window.myMapChartMapMap.setMinZoom(6)
    // window.myMapChartMapMap.addControl(new window.BMap.NavigationControl({
    //   anchor: window.BMAP_ANCHOR_TOP_RIGHT,
    //   offset: new window.BMap.Size(1, 37),
    //   showZoomInfo: false
    // }))
    window.myMapChartMapMap.addEventListener('dblclick', function () {
      dispatch('mapUpdateCurrentArea')
    })
    window.myMapChartMapMap.addEventListener('mousemove', function (d1) {
      dispatch('setMapMouseMoveIng', [d1.offsetX, d1.offsetY, d1.currentTarget.width, d1.currentTarget.height, d1.point])
      dispatch('setMousePonit', [d1.offsetX, d1.offsetY, d1.currentTarget.width, d1.currentTarget.height, d1.point])
    })
    window.myMapChartMapMap.addEventListener('click', function (data) {
      if (!getters.mapChartClick) {
        dispatch('setMapChooseDepot', null)
        dispatch('setMapChoosePipe', null)
        dispatch('setMapChartClickGasName', null)
      }
      dispatch('setMapChartClick', false)
    })
    window.myMapChartMapMap.addEventListener('zoomend', function (data) {
      dispatch('setMapChartMapZoom', window.myMapChartMapMap.getZoom())
    })
    window.myMapChartMapMap.addEventListener('rightclick', function (data) {
      if (!getters.mapBackCurrentAreaing) {
        dispatch('mapBackCurrentArea')
      }
    })
    window.mapAreaHzHis = []
    dispatch('mapUpdateCurrentArea')
    dispatch('setMapLoading', getters.mapLoading + 1)
  },
  mapCharMapHover2 ({ getters, dispatch }, data) {
    let inArea = false
    window.mapAreaHzHis.forEach((item) => {
      if (item.name !== '云南省' && window.BMapLib.GeoUtils.isPointInPolygon(data, item.plyList[0])) {
        item.plyList[0].setStrokeWeight(xzqhStyleConfig.hoverShi.strokeWeight)
        dispatch('setMapCurrentHoverArea', item.name)
        inArea = true
      } else {
        item.plyList[0].setStrokeWeight(xzqhStyleConfig.norm.strokeWeight)
      }
    })
    if (!inArea) {
      dispatch('setMapCurrentHoverArea', null)
    }
  },
  mapBackCurrentArea ({ getters, dispatch }) {
    if (getters.mapChartIsBrush) {
      return
    }
    dispatch('setMapBackCurrentAreaing', true)
    setTimeout(() => {
      dispatch('setMapBackCurrentAreaing', false)
    }, 500)
    let currentArea = {
      sheng: getters.mapCurrentArea.sheng,
      shi: getters.mapCurrentArea.shi,
      qx: getters.mapCurrentArea.qx
    }
    if (currentArea.qx) {
      currentArea.qx = null
    } else if (currentArea.shi) {
      currentArea.shi = null
    }
    dispatch('setMapCurrentArea', currentArea)
  },
  mapUpdateCurrentArea ({ getters, dispatch }) {
    let currentArea = {
      sheng: getters.mapCurrentArea.sheng,
      shi: getters.mapCurrentArea.shi,
      qx: getters.mapCurrentArea.qx
    }
    let hoverArea = getters.mapCurrentHoverArea
    if (hoverArea === '云南省') {
      currentArea = {
        sheng: hoverArea,
        shi: null,
        qx: null
      }
    } else if (hoverArea) {
      let hoverType = 'qx'
      getters.mapAreaShi.forEach((item) => {
        if (item.name === hoverArea) {
          hoverType = item.level
        }
      })
      if (hoverType === 'qx') {
        currentArea.qx = hoverArea
      } else {
        currentArea.shi = hoverArea
        currentArea.qx = null
      }
    }
    dispatch('setMapCurrentArea', currentArea)
  },
  mapLoadBmapApi () {
    let script = document.createElement('script')
    script.src = 'https://api.map.baidu.com/api?v=2.0&ak=O8eyfQgNIOYnnGYqM2xVAqXtmqkyk6CT&callback=initMapBaidu'
    document.body.appendChild(script)
  },
  loadMapSourceData ({ dispatch, getters }) {
    if (getters.mapNoGas) {
      dispatch('setMapLoading', getters.mapLoading + 1)
      return
    }
    mapGetDataNew().then((data) => {
      let allData = convertData(data.data)
      let gasNames = []
      let areaShi = {}
      let areaShiValue = {}
      let areaQx = {}
      let areaShiList = []
      allData.forEach((item) => {
        gasNames.push(item.name)
        if (!areaShi[item.area]) {
          areaShi[item.area] = []
        }
        if (!areaShi[item.area].includes(item.areaQx)) {
          areaShi[item.area].push(item.areaQx)
        }
        if (!areaQx[item.areaQx]) {
          areaQx[item.areaQx] = {
            zsy: 0,
            other: 0
          }
        }
        if (!areaShiValue[item.area]) {
          areaShiValue[item.area] = {
            zsy: 0,
            other: 0,
            zsy17: 0
          }
        }
        if (item.group === sysEnv.zsyName) {
          areaQx[item.areaQx].zsy += item.totalSale || 0
          areaShiValue[item.area].zsy += item.totalSale || 0
          areaShiValue[item.area].zsy17 += Number(item.sale17) || 0
        } else {
          areaQx[item.areaQx].other += item.totalSale || 0
          areaShiValue[item.area].other += item.totalSale || 0
        }
      })
      let shiSczb = {}
      shiZb.forEach((item) => {
        shiSczb[item.area] = {
          cnpc: Number(item.cnpc),
          snpc: Number(item.snpc)
        }
      })
      let i = 0
      for (let key in areaShi) {
        let itemData = {
          name: key,
          level: 'shi',
          value: areaShiValue[key].zsy,
          value2: shiSczb[key] ? shiSczb[key].cnpc : null,
          value3: shiSczb[key] ? shiSczb[key].snpc : null,
          valueTb: (areaShiValue[key].zsy - areaShiValue[key].zsy17) / areaShiValue[key].zsy,
          valueHb: i % 2 === 0 ? 0.8 : 1.2,
          qx: []
        }
        areaShi[key].forEach((item) => {
          itemData.qx.push({
            name: item,
            level: 'qx',
            value: areaQx[item] ? areaQx[item].zsy / ((areaQx[item].zsy + areaQx[item].other) || 1) : 0
          })
        })
        areaShiList.push(itemData)
        i += 1
      }
      dispatch('setMapSourceData', allData)
      dispatch('setMapGass', gasNames)
      dispatch('setMapAreaShi', areaShiList)
      dispatch('setMapLoading', getters.mapLoading + 1)
    })
  },
  setMapLoading ({ commit, dispatch, getters }, data) {
    commit('setMapLoading', data)
    if (data > 2) {
      dispatch('mapUpdateMapData')
      dispatch('mapXzqhHz')
    }
  },
  setMapMouseMoveIng ({ commit, getters, dispatch }, data) {
    commit('setMapMouseMoveIng', true)
    setTimeout(function () {
      if (data[0] === getters.mousePonit[0] && data[1] === getters.mousePonit[1]) {
        commit('setMapMouseMoveIng', false)
        dispatch('mapCharMapHover2', data[4])
      }
    }, 200)
  },
  setMapCurrentArea ({ commit, dispatch }, data) {
    commit('setMapCurrentArea', data)
    dispatch('mapCurrentAreaChange')
  },
  setMapNoGas ({ commit }, data) {
    commit('setMapNoGas', data)
  },
  setMapNoDepot ({ commit }, data) {
    commit('setMapNoDepot', data)
  },
  setMapChooseDepot ({ commit }, data) {
    commit('setMapChooseDepot', data)
  },
  setMapChoosePipe ({ commit }, data) {
    commit('setMapChoosePipe', data)
  },
  setMapInitConfig ({ commit }, data) {
    commit('setMapInitConfig', data)
  },
  mapCurrentAreaChange ({ getters, dispatch }) {
    // 设置地图显示区域
    let currentArea = getters.mapCurrentArea.qx || getters.mapCurrentArea.shi || getters.mapCurrentArea.sheng
    let pointArray = null
    window.mapAreaHzHis.forEach((item) => {
      if (item.name === currentArea) {
        pointArray = item.pointArray
        item.plyList.forEach((ply) => {
          // 选重后都不改变颜色了
          // ply.setFillOpacity(xzqhStyleConfig.activeShi.fillOpacity)
          ply.setStrokeColor(xzqhStyleConfig.activeShi.strokeColor)
          ply.setStrokeWeight(xzqhStyleConfig.activeShi.strokeWeight)
        })
      } else {
        item.plyList.forEach((ply) => {
          // 选重后都不改变颜色了
          // ply.setFillOpacity(xzqhStyleConfig.norm.fillOpacity)
          ply.setStrokeColor(getters.mapHotColorType === 1 ? xzqhStyleConfig.norm.strokeColor : '#f0f0f0')
          ply.setStrokeWeight(xzqhStyleConfig.norm.strokeWeight)
        })
      }
    })
    // 更新统计数据
    dispatch('updateMapChartSearchData')
    dispatch('mapXzqhHz')
    if (currentArea !== '云南省' && pointArray) {
      setMapViewport(window.myMapChartMapMap, pointArray)
    } else {
      dispatch('updateChartMap', getters.mapInitConfig)
    }
  },
  updateChartMap ({ getters }, {ponit, zoom}) {
    updateMapCenterAndZoom(window.myMapChartMapMap, ponit, zoom)
    window.myMapChartMap.dispatchAction({
      type: 'mapSelect'
    })
  },
  updateMapLegendseStatus ({ commit, dispatch }, data) {
    commit('updateMapLegendseStatus', data)
    window.myMapChartMap.dispatchAction({
      type: data.data ? 'legendSelect' : 'legendUnSelect',
      name: data.key
    })
  },
  reMapXzqhHz ({ dispatch }) {
    window.mapAreaHzHis.forEach((item) => {
      item.plyList.forEach((itemP) => {
        window.myMapChartMapMap.removeOverlay(itemP)
      })
    })
    window.mapAreaHzHis = []
    dispatch('mapXzqhHz')
  },
  mapXzqhHz ({ getters, dispatch }) {
    // 需要绘制的
    let needHzList = []
    let needHzNames = []
    if (getters.mapCurrentArea.sheng) {
      // 需要绘制的名称
      getters.mapAreaSheng.forEach((item) => {
        needHzList.push(item)
        needHzNames.push(item.name)
      })
      if (getters.mapXzqhHzLevel.includes('shi')) {
        getters.mapAreaShi.forEach((item) => {
          needHzList.push(item)
          needHzNames.push(item.name)
        })
      }
    }
    // 有当前市 绘制区县边界线
    if (getters.mapCurrentArea.shi && getters.mapXzqhHzLevel.includes('qx')) {
      let areaQxs = []
      getters.mapAreaShi.forEach((item) => {
        if (item.name === getters.mapCurrentArea.shi) {
          areaQxs = item.qx
        }
      })
      areaQxs = areaQxs || []
      // 需要绘制的名称
      areaQxs.forEach((item) => {
        needHzList.push(item)
        needHzNames.push(item.name)
      })
    }
    let hzOver = []
    let reHz = []
    window.mapAreaHzHis.forEach((item) => {
      // 需要清空的
      if (item.hzOk && !needHzNames.includes(item.name)) {
        item.plyList.forEach((itemP) => {
          window.myMapChartMapMap.removeOverlay(itemP)
        })
        item.hzOk = false
      }
      // 需要再次绘制的
      if (!item.hzOk && needHzNames.includes(item.name)) {
        item.plyList.forEach((itemP) => {
          window.myMapChartMapMap.addOverlay(itemP)
        })
        item.hzOk = true
        reHz.push(item.name)
      }
      // 已绘制的
      if (item.hzOk && needHzNames.includes(item.name)) {
        hzOver.push(item.name)
      }
    })
    // 需要从新绘制的
    let huiZlist = []
    needHzList.forEach((item) => {
      if (!reHz.concat(hzOver).includes(item.name)) {
        huiZlist.push(item)
      }
    })
    mapXzqh(window.myMapChartMapMap, huiZlist, function (data) {
      dispatch('mapXzqhHzOver', data)
    }, function (area, ply, isOut) {
      dispatch('mapCharMapHover', {area, ply, isOut})
    }, getters.mapDownType, getters.mapHotType, getters.mapHotColorType, getters.mapViewType === 'cc')
  },
  mapXzqhHzOver ({ dispatch }, data) {
    window.mapAreaHzHis.push(data)
  },
  mapCharMapHover ({ getters, dispatch }, {area, ply, isOut}) {
    if (isOut) {
      // 移除后不改变透明度了
      // ply.setFillOpacity(xzqhStyleConfig.norm.fillOpacity)
      ply.setStrokeWeight(xzqhStyleConfig.norm.strokeWeight)
      dispatch('setMapCurrentHoverArea', null)
    } else {
      // 鼠标移入
      // 若当前最小级为省
      // 则市级会变色
      if (!getters.mapCurrentArea.qx && !getters.mapCurrentArea.shi && getters.mapCurrentArea.sheng) {
        if (area.level === 'shi') {
          // 移入后也不改变透明度了
          // ply.setFillOpacity(xzqhStyleConfig.hoverShi.fillOpacity)
          ply.setStrokeWeight(xzqhStyleConfig.hoverShi.strokeWeight)
          dispatch('setMapCurrentHoverArea', area.name)
        }
      }
      // 若当前最小级为市
      // 市及该市下区县会变色
      if (!getters.mapCurrentArea.qx && getters.mapCurrentArea.shi && getters.mapCurrentArea.sheng) {
        if (['shi'].includes(area.level)) {
          // 移入后也不改变透明度了
          // ply.setFillOpacity(xzqhStyleConfig.hoverShi.fillOpacity)
          ply.setStrokeWeight(xzqhStyleConfig.hoverShi.strokeWeight)
          dispatch('setMapCurrentHoverArea', area.name)
        } else if (['qx'].includes(area.level)) {
          // ply.setFillOpacity(xzqhStyleConfig.hoverShi.fillOpacity)
          ply.setStrokeWeight(xzqhStyleConfig.hoverShi.strokeWeight)
          dispatch('setMapCurrentHoverArea', area.name)
        }
      }
      // 若当前最小级为区县
      // 对应市下区县、其他市 会变色
      if (getters.mapCurrentArea.qx && getters.mapCurrentArea.shi && getters.mapCurrentArea.sheng) {
        if (['shi'].includes(area.level) && area.name !== getters.mapCurrentArea.shi) {
          // 移入后也不改变透明度了
          // ply.setFillOpacity(xzqhStyleConfig.hoverShi.fillOpacity)
          ply.setStrokeWeight(xzqhStyleConfig.hoverShi.strokeWeight)
          dispatch('setMapCurrentHoverArea', area.name)
        } else if (['qx'].includes(area.level) && area.name !== getters.mapCurrentArea.shi) {
          // ply.setFillOpacity(xzqhStyleConfig.hoverShi.fillOpacity)
          ply.setStrokeWeight(xzqhStyleConfig.hoverShi.strokeWeight)
          dispatch('setMapCurrentHoverArea', area.name)
        }
      }
    }
  },
  setMapChartMap ({ commit }, data) {
    commit('setMapChartMap', data)
  },
  setMapChartMapZoom ({ commit, getters, dispatch }, data) {
    let hisZoom = getters.mapChartMapZoom
    commit('setMapChartMapZoom', data)
    window.myMapChartMap.dispatchAction({
      type: 'mapSelect'
    })
    if ((hisZoom > 11 && getters.mapChartMapZoom > 11) || (!getters.mapNeedMerge)) {
      return
    }
    Vue.nextTick(function () {
      dispatch('mapUpdateMapData')
    })
  },
  setMapCurrentHoverArea ({ commit, getters }, data) {
    commit('setMapCurrentHoverArea', data)
  },
  setMapBackCurrentAreaing ({ commit }, data) {
    commit('setMapBackCurrentAreaing', data)
  },
  setMapChartClickGasName ({ commit }, data) {
    commit('setMapChartClickGasName', data)
  },
  setMapChartSearchData ({ commit }, data) {
    commit('setMapChartSearchData', data)
  },
  setMapChartClick ({ commit }, data) {
    commit('setMapChartClick', data)
  },
  setMapLegendseStatus ({ commit, dispatch }, data) {
    commit('setMapLegendseStatus', data)
    dispatch('updateMapChartSearchData')
  },
  setMousePonit ({ commit }, data) {
    commit('setMousePonit', data)
  },
  initMapLegendseStatus ({ commit, dispatch }, data) {
    commit('setMapLegendseStatus', data)
  },
  setMapChartSelectData ({ commit }, data) {
    commit('setMapChartSelectData', data)
  },
  setMapChartIsBrush ({ commit }, data) {
    commit('setMapChartIsBrush', data)
  },
  setMapSeriesData ({ commit }, data) {
    commit('setMapSeriesData', data)
  },
  addMapSeriesData ({ commit }, data) {
    commit('addMapSeriesData', data)
  },
  mapUpdateMapData ({ dispatch, getters }) {
    dispatch('setMapChartSelectData', [])
    let mapDataZsy = []
    let mapDataZsyYj = []
    let mapDataZsh = []
    let mapDataZy = []
    getters.mapSourceData.forEach((item, index) => {
      if (getters.mapChooseSaleType.includes(item.saleType) &&
        (!getters.mapChooseGasType || item.gasType === getters.mapChooseGasType) &&
        (getters.mapChooseOil === 'all' || item[getters.mapChooseOil]) &&
        (getters.mapChooseCmp === 'all' || item.cmp === getters.mapChooseCmp)) {
        if (item.group === sysEnv.zsyName) {
          if (item.isWarning) {
            mapDataZsyYj.push({name: item.name, value: item.point, data: item})
          } else {
            mapDataZsy.push({name: item.name, value: item.point, data: item})
          }
        } else if (item.group === '中石化') {
          mapDataZsh.push({name: item.name, value: item.point, data: item})
        } else if (item.group === '社会站') {
          mapDataZy.push({name: item.name, value: item.point, data: item})
        }
      }
    })
    dispatch('addMapSeriesData', {index: 0, data: getters.mapNeedMerge ? pointAggregation(mapDataZsy, getters.mapChartMapZoom) : mapDataZsy})
    dispatch('addMapSeriesData', {index: 1, data: getters.mapNeedMerge ? pointAggregation(mapDataZsh, getters.mapChartMapZoom) : mapDataZsh})
    dispatch('addMapSeriesData', {index: 2, data: getters.mapNeedMerge ? pointAggregation(mapDataZy, getters.mapChartMapZoom) : mapDataZy})
    dispatch('addMapSeriesData', {index: 7, data: getters.mapShowWarning ? mapDataZsyYj : []})
    dispatch('addMapSeriesData', {index: 3, data: getters.mapChooseDepotCompany[sysEnv.zsyName] && getters.mapChooseDepotType['管道库'] ? getters.mapSourceDataOther.ykZsy1 : []})
    dispatch('addMapSeriesData', {index: 14, data: getters.mapChooseDepotCompany[sysEnv.zsyName] && getters.mapChooseDepotType['铁路库'] ? getters.mapSourceDataOther.ykZsy2 : []})
    dispatch('addMapSeriesData', {index: 15, data: getters.mapChooseDepotCompany[sysEnv.zsyName] && getters.mapChooseDepotType['地付'] ? getters.mapSourceDataOther.ykZsy3 : []})
    dispatch('addMapSeriesData', {index: 10, data: getters.mapChooseDepotCompany['中石化'] ? getters.mapSourceDataOther.ykZsh : []})
    dispatch('addMapSeriesData', {index: 11, data: getters.mapChooseDepotCompany['国储'] ? getters.mapSourceDataOther.ykGc : []})
    dispatch('addMapSeriesData', {index: 12, data: getters.mapChooseDepotCompany['中航油'] ? getters.mapSourceDataOther.ykZhy : []})
    dispatch('addMapSeriesData', {index: 13, data: getters.mapChooseDepotCompany['社会'] ? getters.mapSourceDataOther.ykSh : []})
    dispatch('addMapSeriesData', {index: 4, data: getters.mapGdCmp[sysEnv.zsyName] ? getters.mapSourceDataOther.gxZsy : []})
    dispatch('addMapSeriesData', {index: 5, data: getters.mapGdCmp['中石化'] ? getters.mapSourceDataOther.gxZsh : []})
    dispatch('mapUpdateCharData')
    dispatch('updateMapChartSearchData')
  },
  mapUpdateCharData ({ getters }) {
    let depotBaseSize = getters.mapViewType === 'cc' ? 150 : 100
    let getSizeFun = (data) => {
      let zoom = getters.mapChartMapZoom
      let size = 30
      if (data) {
        size = getters.mapChooseOil === 'all' ? (data['size' + getters.mapChooseVolumeType] || 0) : (data[String(getters.mapChooseOil)] ? (data[String(getters.mapChooseOil)]['size' + getters.mapChooseVolumeType] || 0) : 0)
      }
      if (!size) {
        size = data.length + 30
        size = size > 65 ? 65 : size
      }
      if (data && data.isWarning) {
        size = size * 3
      }
      if (data && data.seriesId && data.seriesId.includes('depot')) {
        size = depotBaseSize / (Number(data.data.data.level) === 3 || !data.data.data.level ? 1.3 : 1)
      }
      return size * zoom / (zoom < 9 ? 25 : 15)
    }
    let tooltipF = getters.userInfo.currentRole && getters.userInfo.currentRole.name === '数据分析' ? tooltipF1 : tooltipF2
    let option = initGasOptionNew(getSizeFun, getters.mapSeriesData, tooltipF, getters.mapLegendseStatus, null, getters.mapViewType === 'cc')
    window.myMapChartMap.setOption({series: option.series}, false, false, false)
    window.myMapChartMapMap.disableDoubleClickZoom()
  },
  setMapViewType ({ commit }, data) {
    commit('setMapViewType', data)
  },
  setMapAreaShi ({ commit }, data) {
    commit('setMapAreaShi', data)
  },
  setMapSourceData ({ commit }, data) {
    commit('setMapSourceData', data)
  },
  setMapSourceDataOther ({ commit }, data) {
    commit('setMapSourceDataOther', data)
  },
  setMapDownType ({ commit }, data) {
    commit('setMapDownType', data)
  },
  setMapOverChart ({ commit }, data) {
    commit('setMapOverChart', data)
  }
}

const mutations = {
  setMapViewType (state, data) {
    state.mapViewType = data
  },
  setMapChooseDepot (state, data) {
    state.mapChooseDepot = data
  },
  setMapChoosePipe (state, data) {
    state.mapChoosePipe = data
  },
  setMapOverChart (state, data) {
    state.mapOverChart = data
  },
  mapClearData (state, data) {
    clearStateData(state)
  },
  setMapMouseMoveIng (state, data) {
    state.mapMouseMoveIng = data
  },
  setMousePonit (state, data) {
    state.mousePonit = data
  },
  updateMapLegendseStatus (state, {key, data}) {
    state.mapLegendseStatus[key] = data
  },
  setMapSeriesData (state, data) {
    state.mapSeriesData = data
  },
  setMapInitConfig (state, data) {
    state.mapInitConfig = data
  },
  addMapSeriesData (state, {index, data}) {
    state.mapSeriesData[index] = data
  },
  setMapCurrentHoverArea (state, data) {
    state.mapCurrentHoverArea = data
  },
  setMapBackCurrentAreaing (state, data) {
    state.mapBackCurrentAreaing = data
  },
  setMapChartMapZoom (state, data) {
    state.mapChartMapZoom = data
  },
  setMapCurrentArea (state, data) {
    state.mapCurrentArea = data
  },
  setMapChartClickGasName (state, data) {
    state.mapChartClickGasName = data
  },
  setMapChartClick (state, data) {
    state.mapChartClick = data
  },
  setMapLegendseStatus (state, data) {
    state.mapLegendseStatus = data
  },
  setMapChartSearchData (state, data) {
    state.mapChartSearchData = data
  },
  setMapChartSelectData (state, data) {
    state.mapChartSelectData = data
  },
  setMapChartIsBrush (state, data) {
    state.mapChartIsBrush = data
  },
  setMapAreaShi (state, data) {
    state.mapAreaShi = data
  },
  setMapLoading (state, data) {
    state.mapLoading = data
  },
  setMapSourceData (state, data) {
    state.mapSourceData = data
  },
  setMapSourceDataOther (state, data) {
    state.mapSourceDataOther = data
  },
  setMapNoGas (state, data) {
    state.mapNoGas = data
  },
  setMapNoDepot (state, data) {
    state.mapNoDepot = data
  },
  setMapDownType (state, data) {
    state.mapDownType = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/map/map.js